export const getBuildType = () => {
  return process.env.REACT_APP_BUILD_TYPE;
};
